<script setup lang="ts">
import {computed, ref} from "vue";
import LoginDialog from "components/dialog/LoginDialog.vue";
import {userUserStore} from "@/store/user.ts";
import {useRouter} from "vue-router";
import FeedbackDialog from "components/dialog/FeedbackDialog.vue";
import {SystemService} from "@/api/api.ts";
import {ElNotification} from "element-plus";

const userStore = userUserStore();
const router = useRouter();
const loginDialog = ref<InstanceType<typeof LoginDialog> | null>();
const feedbackDialog = ref<InstanceType<typeof FeedbackDialog> | null>();

const onLoginBtnClick = () => {
  loginDialog.value?.showLoginDialog();
}

const onCreatorCenterClick = () => {
  router.push("/creator");
}

const isLogin = computed(() => userStore.token && userStore.token.length > 0)

const feedback = () => {
  feedbackDialog.value?.show()
}

const submitFeedback = async (info: any) => {
  try {
    const res = await SystemService.feedback(info)
    if (res.data.code === 200) {
      ElNotification.success({
        message: res.data.msg,
      })
      feedbackDialog.value?.hide()
    } else {
      ElNotification.error({
        message: res.data.msg,
      })
    }
  } catch (e) {
    console.log(e)
  }
}

const getSystemInfo = (name: string) => {
  const routeData = router.resolve({
    name: 'Privacy',
    params: {
      name: name
    }
  })
  window.open(routeData.href, "_blank");
}
</script>

<template>
  <div id="header">
    <img src="https://view.bioquan.com/web/big-logo.png" class="top-logo" alt="logo"/>
    <div id="account-info">
      <div class="rounded-full px-1.5rem py-.5rem bg-white text-#FF6600CC text-1.25em cursor-pointer"
           @click="onLoginBtnClick" v-show="!isLogin">登录
      </div>
      <img id="account-default" src="@/assets/image/icon/icon-account.png" alt="avatar" v-show="isLogin"
           @click="onCreatorCenterClick"/>
    </div>
  </div>
  <div id="main">
    <div id="content">
      <div class="section">
        星虫成立于2025年，主要开发微同课App线上学习平台，核心功能主要有课堂、测试、AI问、广场，包含竞赛、强基、高考、预科等内容方向，并借助AI大联考、AI视频书、AI智学机、AI智学室的开发与搭建，为学生提供智能教辅、互动学习等课程服务，构建精准听课、智能测评、随时答疑的智能学习新场景。
      </div>
      <br/>
      <br/>
      <div class="section">
        愿景：随时随地，同课同学
      </div>
      <div class="section">
        使命：同一课堂，同一梦想
      </div>
      <div class="section">
        理念：共建共享，共创共赢
      </div>
      <div class="app-intro">
        <img src="@/assets/image/vtongke-logo.png" alt="main-logo" class="w-13rem"/>
        <div class="app-text-intro">
          <div class="text-#161616 font-bold text-1.5em">微同课</div>
          <div class="mt-1rem line-height-8">微同课公益学习平台致力于教育帮扶工程中的学科素养提升，专注于竞赛、强基、高考、预科等课程研发更新和考试逻辑方向的衔接研究，锲而不舍地探索考试逻辑的动态方向，确保每一次知识的传递都精准有力。学子和家长们在平台上可以进行课程学习、随身测试、交流互动，让考试不再陌生，让学习不再迷茫，愿每一位学子跨越知识沧海，金榜题名，奔赴似锦前程，微同课将始终伴你左右，护你远航！</div>
        </div>
      </div>
    </div>
  </div>
  <div id="footer">
    <div class="footer-content">
      <div>
        <div class="contact-header">联系我们</div>
        <div class="contact-item">
          <img src="@/assets/image/icon/icon-phone.png" class="home-icon" alt="phone"/>
          <div class="contact-text">电话：0571-8678-9705</div>
        </div>
        <div class="contact-item">
          <img src="@/assets/image/icon/icon-location.png" class="home-icon" alt="location"/>
          <div class="contact-text">地址：浙江省杭州市海创科技中心3幢1616室</div>
        </div>
        <div class="contact-item">
          <img src="@/assets/image/icon/icon-email.png" class="home-icon" alt="email"/>
          <div class="contact-text">邮箱：vtongkekf@163.com</div>
        </div>
        <div class="contact-item cursor-pointer select-none" @click="feedback">
          <img src="@/assets/image/icon/icon-message.png" class="home-icon" alt="message"/>
          <div class="contact-text bg-submit-message">提交留言</div>
        </div>
      </div>
    </div>
    <div class="absolute bottom-1rem flex justify-center w-full">
      <div>© {{ new Date().getFullYear() }} 微同课</div>
      <div class="mx-.5rem">|</div>
      <div>
        <img src="@/assets/image/icon/icon-beian.png" class="w-.855rem h-.855rem mr-.5rem"  alt="icon-beian"/>
        <a class="decoration-none text-white" href="https://beian.mps.gov.cn/#/query/webSearch?code=33011002016132" target="_blank">浙公网安备33011002016132号</a>
      </div>
      <div class="mx-.5rem">|</div>
      <div>
        <a class="decoration-none text-white" href="https://beian.miit.gov.cn/" target="_blank">浙ICP备2025152279号-1</a>
      </div>
      <div class="mx-.5rem">|</div>
      <div @click="getSystemInfo('隐私协议')" class="cursor-pointer">隐私协议</div>
      <div class="mx-.5rem">|</div>
      <div @click="getSystemInfo('用户协议')" class="cursor-pointer">用户协议</div>
    </div>
    <img src="https://view.bioquan.com/web/main-bottom.png" class="footer-bg" alt="logo"/>
  </div>
  <login-dialog ref="loginDialog"/>
  <feedback-dialog ref="feedbackDialog" @submit="submitFeedback"/>
</template>

<style scoped>
@import "./home.css";
</style>
